<div id="toast" class="card-block">
    <h3 class="card-title">{{title}}</h3>
    <h5 class="card-text">{{message}}</h5>
</div>
